import { createComponent, createHook } from 'reakit-system';
import { DialogHTMLProps, DialogOptions, useDialog } from 'reakit';
import { BoxHTMLProps, BoxOptions, useBox } from '../Box/Box';
import { WHCM } from '../constants';

/**
 * @internal
 */
type ModalContainerOptions = DialogOptions &
  BoxOptions & { modalSize: 'small' | 'default' };
type ModalContainerProps = DialogHTMLProps & BoxHTMLProps;

export const useModalContainer = createHook<
  ModalContainerOptions,
  ModalContainerProps
>({
  compose: [useBox, useDialog],
  keys: ['modalSize'],
  useOptions(options) {
    return {
      preventBodyScroll: false,
      boxShadow: 'modal',
      bg: 'white',
      position: 'relative',
      width: 1,
      display: 'flex',
      flexDirection: 'column',
      alignSelf: ['flex-end', 'center'],
      minHeight: ['modalMinHeight', 0],
      overflow: 'hidden',
      zIndex: 1010,
      ...options,

      styles: {
        label: 'ModalContainer',
        fontSize: 'textBase',
        color: 'gray-90',
        lineHeight: 'textBaseLineHeight',
        borderRadius: ['modal', 'modalBig'],
        '& [class*="ModalContent"]': {
          overscrollBehavior: 'contain',
        },
        [WHCM]: {
          border: 2,
        },
        ...options.styles,
      },
    };
  },
});

/**
 * @internal
 */
export const ModalContainer = createComponent({
  useHook: useModalContainer,
  as: 'div',
});
